<template>
  <div class="page-wrapper" style="max-width: 750px; margin: 0 auto">
    <div class="img-wrapper" :style="{ paddingBottom: offsetHeight + 'px' }">
      <img class="page-img" src="./images/page-01.png" alt="" />
      <img class="page-img" src="./images/page-02.png" alt="" />
      <img class="page-img" src="./images/page-03.png" alt="" />
    </div>
    <div ref="btnWrapper" class="page-btns">
      <div class="page-btn-item" @click="gotoDownloadPage">Download Now</div>
      <WxOpenLaunchAppLocal
        style="flex: 1;"
        :extinfoProps="goAppRouter"
        v-if="wechatAppid"
        :appid="wechatAppid"
        @click="wechatAppid = ''"
        :clientWidth="$root.clientWidth"
        :clientHeight="$root.clientHeight"
        @launch-error="launchError"
      >
        <div class="page-btn-item clear" @click="tryOpenApp">Order Now</div>
      </WxOpenLaunchAppLocal>
      <div v-else class="page-btn-item" @click="tryOpenApp">Order Now</div>
    </div>
    <OpenStep v-model="stepVisible" />
  </div>
</template>

<script>
import OuterCasing from "$common/components/component-outer-casing";
import languageUtils from "$common/utils/language";
import OpenStep from "$common/components/open-step";
// import WxOpenLaunchApp from '$common/components/wechat/wx-open-launch-app';
import WxOpenLaunchAppLocal from '$common/components/wechat/wx-open-launch-app-local';
import Toast from 'vant/es/toast/index'
import 'vant/es/toast/index.css'
import 'vant/es/toast/style/index';
import { pageEvent } from '$common/utils/event-tracking/page';

export default {
  documentTitle: "WOWNOW",

  components: {
    OuterCasing,
    OpenStep,
    // WxOpenLaunchApp,
    WxOpenLaunchAppLocal
  },

  computed: {
    isDingTalk: () =>
      navigator.userAgent.toLowerCase().indexOf("dingtalk") !== -1,
    isIOS: () =>
      navigator.userAgent.toLocaleLowerCase().indexOf("mac os x") !== -1,
    isQQ: () => navigator.userAgent.toLowerCase().indexOf("qq/") !== -1,
    isAndroid: () =>
      navigator.userAgent.toLocaleLowerCase().indexOf("android") !== -1,
    isWechat: () =>
      navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1,
    lang() {
      const navigatorLanguage = languageUtils.getPageHeaderCurrentLanguage;
      return navigatorLanguage.indexOf("zh") !== -1
        ? "zh"
        : navigatorLanguage.indexOf("en") !== -1
          ? "en"
          : "km";
    },
    locationQuery() {
      let queries = {};
      try {
        let search = window.location.search.match(/\?.*(?=\b|#)/);
        if (search) {
          search = search[0].replace(/^\?/, "");
        }
        if (search) {
          search.split('&').forEach((item) => {
            const param = item.split('=');
            if (param[1]) {
              queries[param[0]] = decodeURIComponent(param[1])
            }
          });
        }
        const routePath = queries.routePath || queries.routepath || ''
        if ((routePath?.indexOf?.('shortID')) !== -1 && queries?.shortID) {
          delete queries.shortID;
        }
        if (typeof window?.ssrConfig?.routerConfig?.short?.params === 'object' && !Array.isArray(window?.ssrConfig?.routerConfig?.short?.params)) {
          queries = Object.assign({}, queries, window.ssrConfig.routerConfig.short.params);
        }
        return queries;
      } catch (err) {
        console.log("整理参数失败: ", err);
        return {};
      }
    },
    currentSchemeUrl() {
      if (this?.locationQuery?.isH5) {
        return `${
          (this.isIOS && this.iosUrl) || "superapp://tinhnow/route?url="
        }${this.locationQuery.routePath}`;
      }
      if (this.isIOS) {
        return `${this.iosUrl}${this?.locationQuery?.routePath ?? ""}`;
      }
      if (this.androidUrl === 'superapp://wownow/route?url=') {
        return `${this.androidUrl}${this?.locationQuery?.routePath}`;
      } else {
        return `${this.androidUrl}${this?.locationQuery?.routePath?.replace?.(/SuperApp%3A%2F%2F|SuperApp:\/\//, '') ?? "YumNow/storeDetail"}`;
      }
    },
    goAppRouter() {
      return decodeURIComponent(this?.locationQuery?.routePath ?? '');
    }
  },

  mounted() {
    this.setOffset();
    pageEvent({
      businessName: '彩票落地页'
    });
  },

  data() {
    return {
      maxWidth: 420,
      stepVisible: false,
      offsetHeight: 0,
      // wownowTool
      // window.wownowTool.getScheme
      wechatAppid: window?.ssrConfig?.routerConfig?.appid ?? '',
      iosUrl: window.wownowTool.getScheme(window?.ssrConfig?.routerConfig?.scheme?.ios ?? "superapp://h5.lifekh.com/wakeup?routepath="),
      androidUrl: window.wownowTool.getScheme(window?.ssrConfig?.routerConfig?.scheme?.android ?? "yumnow://")
    };
  },
  methods: {
    launchError(res) {
      console.log(res)
      console.log('launch error')
    },
    setOffset() {
      setTimeout(() => {
        const ref = this.$refs.btnWrapper;
        const rect = ref.getBoundingClientRect();
        const height = rect.height;
        this.offsetHeight = height;
      }, 100);
    },
    gotoBuriedDownload() {
      return pageEvent({
        event: '@click',
        eventGroup: 'click',
        businessName: '按钮点击_DownloadNow'
      });
    },
    gotoDownloadPage() {
      Toast.loading({
        duration: 0
      });
      this.gotoBuriedDownload()
        .then(() => {
          Toast.clear()
          const origin = window.location.origin;
          const href = window.location.href;
          const search = href.split("?")[1];
          const query = search ? "?" + search : "";
          let path = "";
          if (process.env.NODE_ENV === "development") {
            path = `${origin}/wownow/down-loading${query}`;
          } else {
            path = `${origin}/mobile-h5/wownow/down-loading${query}`;
          }
          window.location.href = path;
        })
    },
    gotoBuriedOpenApp() {
      return pageEvent({
        event: '@click',
        eventGroup: 'click',
        businessName: '按钮点击_OrderNow'
      }).finally(() => console.log('Order Now埋点done! '));
    },
    tryOpenApp() {
      Toast.loading({
        duration: 0
      });
      this.gotoBuriedOpenApp()
        .then(() => {
          Toast.clear()
          if (this.isQQ || this.isDingTalk || this.isWechat) {
            this.stepVisible = true;
            return;
          }
          window.location.href = this.currentSchemeUrl;
          setTimeout(() => {
            this.gotoDownloadPage();
          }, 1000);
        })
    }
  }
};
</script>

<style lang="stylus">
// @supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
// 	.page-wrapper {
//     height: calc(100% - constant(safe-area-inset-bottom)) !important;
//     height: calc(100% - env(safe-area-inset-bottom)) !important;
//   }
// }
</style>

<style lang="stylus" scoped>
.page-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  .img-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
    padding-bottom: 60px;

    .page-img {
      display: block;
      width: 100%;
      max-width: 100%;
      overflow: hidden;
    }
  }
}

.page-btns {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  padding: 10px 14px;
  justify-content: space-between;
  background-color: #fff;

  .page-btn-item {
    flex: 1;
    border-radius: 20px;
    background-color: #f26e32;
    margin-right: 10px;
    color: #fff;
    padding: 12px 0;
    font-size: 16px;
    font-weight: bold;
    text-align: center;

    &.clear {
      margin-right: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>

<style lang="stylus">
html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, img, ins, kbd, q, s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li, fieldset, form, label, legend, table, caption, tbody, tfoot, thead, tr, th, td, article, aside, canvas, details, embed, figure, figcaption, footer, header, menu, nav, output, ruby, section, summary, time, mark, audio, video, input {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font-weight: normal;
  vertical-align: baseline;
  box-sizing: border-box;
  outline: none;
}

body {
  line-height: 1;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

a {
  color: #7e8c8d;
  -webkit-backface-visibility: hidden;
  text-decoration: none;
}

li {
  list-style: none;
}

body, html {
  position: relative;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  line-height: 1;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  text-size-adjust: none;
  text-rendering: optimizeLegibility;
  -webkit-text-size-adjust: none;
  -webkit-touch-callout: none;
  -webkit-font-smoothing: antialiased;
  -webkit-backface-visibility: hidden;
  -webkit-user-drag: none;
  background: transparent;
  // background: -webkit-linear-gradient(0deg, #f16f31 0%, #e02339 100%);
  // background: -moz-linear-gradient(0deg, #f16f31 0%, #e02339 100%);
  // background: -o-linear-gradient(0deg, #f16f31 0%, #e02339 100%);
  // background: -ms-linear-gradient(0deg, #f16f31 0%, #e02339 100%);
  // background: linear-gradient(90deg, #f16f31 0%, #e02339 100%);
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  overflow: hidden;
}

.scroll-touch {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.display-middle {
  display: inline-block;
  vertical-align: middle;
}
</style>
